module.exports = __webpack_public_path__ + "images/feature/lanhu-dialog@2x-a0d58e6d3e7dad59123558b14d6893b3.png";